import type { Topic } from '@/types/content';

export const topics: Topic[] = [
  {
    id: 'tour-schedule-change',
    title: '某偶像团体巡演临时调整场次，主办方连夜发布说明',
    categorySlug: 'celebrities',
    categoryName: '明星动态',
    summary:
      '原定本周末开场的巡演在开票后宣布调整部分场次，主办方给出的理由与粉丝的疑问同时登上讨论榜，我们把时间线梳理了一遍。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20stage%20spotlight%20silhouette%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-01&orientation=squarish',
    coverAlt: '巡演场次调整话题封面，暖色调抽象拼贴',
    tags: ['巡演', '演出', '行程调整'],
    publishedAt: '2026-09-12 09:20',
    updatedAt: '2026-09-12 14:05',
    heat: 9820,
    views: 128400,
    comments: 2140,
    author: '编辑部 · 星河',
    isFeatured: true,
    isBreaking: true,
    content: [
      {
        heading: '事件经过：开票四十八小时后的那则公告',
        paragraphs: [
          '本周三晚间，巡演主办方通过官方渠道发布公告，称因场馆档期与团队排练安排重叠，将对原定本周末的两场演出时间做出调整，已购票观众可选择换场或全额退票。公告发布的时间点恰好在开票后不足四十八小时，不少观众表示行程已经订好，调整来得有些突然。',
          '公告中列出了换场的具体路径与退票入口，并承诺为受影响观众保留优先选座资格。但与公告同时出现的，是一份被网友整理出的场馆档期表，其中显示同一场地的其他空档期并未被使用，这也成了讨论的起点。',
        ],
      },
      {
        heading: '主办方回应：档期与舞台搭建是主因',
        paragraphs: [
          '针对场馆空档的疑问，主办方在次日中午追加了一份说明，解释称本次巡演的舞台为定制结构，需要连续三天以上的搭建与调试窗口，而周边场地排期恰好被其他活动占用，只能整体后移。说明中同时提到，团队希望保证开场效果，不愿以压缩彩排的方式赶场。',
          '对于已经产生的交通与住宿损失，主办方表示会登记受理，按提交顺序统一处理，但并未承诺全额覆盖。这一表态让讨论从“为什么调整”转向了“观众损失由谁承担”。',
        ],
      },
      {
        heading: '观众与业内人士的两种视角',
        paragraphs: [
          '支持者认为，宁可推迟也要保证舞台质量，是负责任的做法；反对者则指出，开票前理应完成档期确认，临时调整的成本不该主要由观众承担。有从业者在社交平台分享了行业惯例，指出定制舞台与场地方档期的博弈确实常见，但信息发布通常会更早。',
          '值得注意的是，讨论中出现了大量消费者权益相关的科普内容，包括票务平台的服务条款、退改规则的适用范围等，这类信息的转发量甚至超过了事件本身。',
        ],
      },
      {
        heading: '后续与我们的观察',
        paragraphs: [
          '截至发稿，换场登记通道仍在开放，主办方表示将在本周内公布最终场次安排。我们将持续跟进退改处理进度，并在话题页标注更新时间。',
          '这类涉及大量观众利益的事件，关键往往不在情绪，而在信息的完整度：谁在什么时候知道、做了哪些安排、成本如何分摊。把时间线摆清楚，比急着站队更有价值。',
        ],
      },
    ],
  },
  {
    id: 'finale-reaction',
    title: '热播剧迎来大结局，口碑为何在最后两集急转',
    categorySlug: 'film-tv',
    categoryName: '影视播报',
    summary:
      '一部开分不错的剧集在大结局后评分回落，观众的分歧集中在人物动机与结局处理上，我们整理了正反两方最集中的几个观点。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20film%20reel%20and%20rectangle%20framing%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-02&orientation=squarish',
    coverAlt: '剧集大结局口碑话题封面，暖色调抽象拼贴',
    tags: ['大结局', '口碑', '剧评'],
    publishedAt: '2026-09-12 08:40',
    updatedAt: '2026-09-12 13:10',
    heat: 8730,
    views: 96200,
    comments: 1870,
    author: '编辑部 · 放映厅',
    isFeatured: true,
    isBreaking: false,
    content: [
      {
        heading: '从高分开盘到结局回落',
        paragraphs: [
          '这部剧开播前三周表现稳定，主线清晰、配角出彩，评分一度维持在较高水平。转折出现在倒数第三集，主角的一段关键选择被不少观众认为缺乏铺垫，此后讨论开始从剧情细节蔓延到对整部剧立意的质疑。',
          '大结局播出当晚，相关话题的讨论量达到峰值。有意思的是，讨论并非一边倒：认为结局“克制、真实”的观众同样不少，两派的交锋主要在人物动机的合理性上。',
        ],
      },
      {
        heading: '争议焦点一：人物动机是否需要交代得更清楚',
        paragraphs: [
          '反方观点认为，主角最后的选择与前二十集建立的行为逻辑存在断裂，观众需要自行脑补大量背景才能接受，这属于叙事上的偷懒。正方则指出，留白本身是一种表达方式，角色的犹豫与矛盾恰恰更接近真实的人。',
          '双方引用的是同一批镜头，却读出了不同的含义。这恰好说明，评价一部剧的难度往往不在于“好不好”，而在于“为什么这样拍”。',
        ],
      },
      {
        heading: '争议焦点二：支线收尾是否过于仓促',
        paragraphs: [
          '除了主线，几条支线的收束方式也被频繁提及。有观众统计了各条支线在大结局中的时长分配，认为部分铺垫已久的线索只用几个镜头带过，显得匆忙。',
          '也有剧评人指出，长剧在制作周期与播出节奏的双重压力下，结局压缩是常见现象，与其归因于创作态度，不如关注制作流程中哪些环节可以优化。',
        ],
      },
      {
        heading: '给追剧的人几条实用建议',
        paragraphs: [
          '如果你还没看结局，建议先忽略评分再看，评价会明显影响观感预期；如果你已经看完并且意难平，可以回头看一遍主角的中段戏份，很多被认为“断裂”的选择其实埋了伏笔。',
          '我们会在话题页持续补充主创的公开回应与幕后访谈，如果你发现了被忽略的细节，也欢迎通过联系页面提供。',
        ],
      },
    ],
  },
  {
    id: 'variety-new-rule',
    title: '综艺新赛制公布：分组方式为何引发大规模讨论',
    categorySlug: 'variety',
    categoryName: '综艺热点',
    summary:
      '新一季节目在开播前公布了分组规则，选手的抽签方式与保底机制成为争论焦点，节目组随后做了一次补充说明。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20geometric%20grid%20and%20puzzle%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-03&orientation=squarish',
    coverAlt: '综艺新赛制话题封面，暖色调抽象拼贴',
    tags: ['赛制', '分组', '综艺'],
    publishedAt: '2026-09-11 21:30',
    updatedAt: '2026-09-12 10:15',
    heat: 7640,
    views: 78900,
    comments: 1420,
    author: '编辑部 · 橙子',
    isFeatured: true,
    isBreaking: false,
    content: [
      {
        heading: '新规则长什么样',
        paragraphs: [
          '节目组公布的新赛制引入了“双轨分组”：选手先按上一季成绩分为种子与非种子两组，再通过抽签完成配对。规则同时设置了保底机制，保证每位选手至少有一次完整舞台。',
          '从设计意图看，这套规则试图兼顾公平与观赏性——既避免强强过早相遇，也保留随机性带来的戏剧效果。',
        ],
      },
      {
        heading: '讨论升温：抽签的“随机”够不够随机',
        paragraphs: [
          '争议集中在抽签环节。有观众逐帧回看预告片，认为抽签过程缺乏可验证的随机性，并举例说明某些组合出现的概率偏低。节目组随后发布说明，表示抽签全程有第三方在场并留有录像。',
          '也有观众持相反意见，认为这套规则已经比上一季透明许多，对随机性的质疑更多源于对结果的不满，而非流程本身的问题。',
        ],
      },
      {
        heading: '保底机制：善意设计还是变相平衡',
        paragraphs: [
          '保底机制同样被反复讨论。支持者认为它保护了因抽签运气不佳的选手，让比赛更看重长期表现；反对者则担心，保底名额会稀释竞技强度，让前期表现失去意义。',
          '节目组在补充说明中给出了数据：上一季因分组不利而被淘汰的选手中，有相当一部分在复活赛阶段表现突出，这也成了推行保底机制的现实依据。',
        ],
      },
    ],
  },
  {
    id: 'streamer-response',
    title: '直播争议后首度回应：主播放出完整录像时间线',
    categorySlug: 'influencer',
    categoryName: '网红观察',
    summary:
      '针对持续数日的直播争议，当事人发布了一段长达四十分钟的说明视频，逐条回应了外界质疑，也承认了其中一处处理不当。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20broadcast%20wave%20and%20screen%20frame%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-04&orientation=squarish',
    coverAlt: '主播直播争议回应话题封面，暖色调抽象拼贴',
    tags: ['直播', '回应', '创作者'],
    publishedAt: '2026-09-11 19:00',
    updatedAt: '2026-09-12 09:30',
    heat: 9110,
    views: 152300,
    comments: 3060,
    author: '编辑部 · 观察员',
    isFeatured: false,
    isBreaking: true,
    content: [
      {
        heading: '争议从何而来',
        paragraphs: [
          '事情的起点是一次常规直播中的即兴发言。片段被剪辑成短视频传播后，脱离了原有语境，迅速引发争论。随后几天，更多旧片段被翻出并拼接在一起，讨论逐渐失控。',
          '在舆论高峰期，当事人选择暂停直播，并表示会整理完整材料后统一回应。这一沉默持续了四天。',
        ],
      },
      {
        heading: '回应视频里的三个关键点',
        paragraphs: [
          '视频中，当事人首先放出了原直播的完整录像与时间轴，指出被传播的片段前后各有数分钟的上下文；其次，对其中一段确实表达不当的发言作出道歉，表示用词欠考虑；最后，说明了后续会调整直播内容规范。',
          '值得注意的是，视频并未回避剪辑问题之外的其他质疑，而是逐条列出了外界提出的问题与对应说明，这种结构化的回应方式获得了不少中立观众的认可。',
        ],
      },
      {
        heading: '舆论为什么不容易平息',
        paragraphs: [
          '即便回应发布，讨论也没有立刻降温。原因之一是，短视频传播具有很强的惯性，被广泛转发的片段很难被“收回”；原因之二是，公众对创作者的期待正在提高，一次不当表达往往会被放进更长的评价周期里。',
          '有传播学者在评论中提到，切片文化放大了误读的概率，但创作者也应当意识到，直播的即时性本身就是风险的一部分，事前规范比事后澄清更有效。',
        ],
      },
      {
        heading: '对创作者的启示',
        paragraphs: [
          '这件事给内容行业的提示很直接：留好素材、保留时间线、及时回应，是应对争议的三件基础工作。回避往往只会延长舆论周期。',
          '我们会在话题页持续跟进后续处理情况。',
        ],
      },
    ],
  },
  {
    id: 'casting-shift',
    title: '影视项目确认换角，制作方回应档期原因',
    categorySlug: 'film-tv',
    categoryName: '影视播报',
    summary:
      '一部备受关注的剧集在开机前夕更换主演，制作方给出的档期解释与网传版本存在出入，我们把双方说法并列呈现。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20clapperboard%20and%20calendar%20grid%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-05&orientation=squarish',
    coverAlt: '影视项目换角话题封面，暖色调抽象拼贴',
    tags: ['换角', '影视项目', '档期'],
    publishedAt: '2026-09-11 16:10',
    updatedAt: '2026-09-12 08:00',
    heat: 6280,
    views: 61500,
    comments: 980,
    author: '编辑部 · 放映厅',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '换角消息落地',
        paragraphs: [
          '该剧从筹备阶段就备受期待，前期公布的阵容一度被视作项目最大的卖点。临近开机，制作方发布通告确认主演调整，并感谢原定演员此前的配合。',
          '通告措辞克制，仅说明变动与档期协调有关，没有提及更多细节。',
        ],
      },
      {
        heading: '两种说法的差异',
        paragraphs: [
          '网络流传的版本指向创作理念分歧，而制作方的公开口径集中在档期冲突。截至发稿，双方均未提供可核实的项目排期文件，我们也无法确认哪一种说法更接近事实。',
          '在信息不完整的情况下，把两种说法并列呈现，比选择一个更吸引眼球的版本更有意义。',
        ],
      },
      {
        heading: '观众真正关心的是什么',
        paragraphs: [
          '从讨论内容看，观众最在意的其实不是换角本身，而是“换角是否会影响成片质量”。有从业者指出，开机前调整属于行业常态，关键看新阵容与角色的适配度。',
          '项目方表示拍摄计划不变，我们会在后续跟进选角与开机进展。',
        ],
      },
    ],
  },
  {
    id: 'agency-joint-statement',
    title: '两家经纪公司就艺名归属发布联合声明',
    categorySlug: 'celebrities',
    categoryName: '明星动态',
    summary:
      '围绕艺名的使用与归属，两家公司罕见地发布联合声明，厘清了此前的误解，也为同类合作提供了参考样本。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20signature%20line%20and%20document%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-06&orientation=squarish',
    coverAlt: '艺名归属联合声明话题封面，暖色调抽象拼贴',
    tags: ['声明', '版权', '合作'],
    publishedAt: '2026-09-11 11:45',
    updatedAt: '2026-09-11 18:20',
    heat: 5120,
    views: 47300,
    comments: 640,
    author: '编辑部 · 星河',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '一份措辞罕见的联合声明',
        paragraphs: [
          '在娱乐行业，公司之间的争议多以各说各话收场，联合声明并不常见。这次两家公司选择共同发布，并在文中明确划分了艺名的注册、使用与授权边界。',
          '声明不长，但信息密度高：艺名的商标注册方、演出使用的授权路径、以及合作终止后的过渡安排，都做了约定。',
        ],
      },
      {
        heading: '为什么艺名归属容易被忽略',
        paragraphs: [
          '长期以来，艺名常被视作“约定俗成”的使用，缺乏明确的权属文件。一旦艺人流动，围绕艺名的分歧就容易浮出水面，而在此之前，很少有人会提前把条款写清楚。',
          '这次声明被业内视为一次正向示范：把模糊地带提前约定，反而减少了后续的消耗。',
        ],
      },
      {
        heading: '对行业的参考意义',
        paragraphs: [
          '有从业者表示，除了艺名，类似的模糊地带还包括社交账号、过往作品的使用授权等。把这些问题标准化，受益的其实是所有人。',
          '我们会继续关注声明中提到的过渡安排如何落地。',
        ],
      },
    ],
  },
  {
    id: 'music-festival-lineup',
    title: '音乐节阵容公布，首日票务页面一度拥堵',
    categorySlug: 'buzz',
    categoryName: '网络热议',
    summary:
      '一场中型音乐节公布了完整阵容，讨论度远超预期，开票瞬间的访问压力也暴露出票务系统的承载问题。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20sound%20wave%20and%20stage%20light%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-07&orientation=squarish',
    coverAlt: '音乐节阵容话题封面，暖色调抽象拼贴',
    tags: ['音乐节', '票务', '演出'],
    publishedAt: '2026-09-10 20:15',
    updatedAt: '2026-09-11 12:00',
    heat: 6890,
    views: 69800,
    comments: 1120,
    author: '编辑部 · 橙子',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '阵容公布后的第一小时',
        paragraphs: [
          '完整阵容在晚间公布，涵盖了多个风格迥异的乐队与独立音乐人。名单发布后，相关话题迅速进入讨论榜前列，很多乐迷表示“冲着其中两组来的”。',
          '开票时间定在次日中午。不到十分钟，票务页面的等待队列就被拉长，部分用户反映页面反复刷新仍无法进入。',
        ],
      },
      {
        heading: '票务拥堵暴露了什么',
        paragraphs: [
          '主办方随后致歉，说明瞬时访问量超出预估，并启用了排队机制分流。有技术从业者分析，中型演出使用通用票务平台的承载方案，遇到超预期流量确实容易吃力。',
          '讨论也延伸到更普遍的问题：热门演出的购票体验，除了系统能力，还取决于放票策略与实名规则的配合。',
        ],
      },
      {
        heading: '乐迷的两种态度',
        paragraphs: [
          '一部分乐迷认为，票难抢恰恰说明演出市场在恢复，愿意多等一会儿；另一部分则指出，购票体验本身就是产品的一部分，不该被当作“必经的考验”。',
          '主办方表示会追加部分站票并优化排队逻辑，我们会在话题页同步最新放票信息。',
        ],
      },
    ],
  },
  {
    id: 'traffic-rule-update',
    title: '短视频平台调整流量规则，创作者群体反应不一',
    categorySlug: 'industry',
    categoryName: '行业风云',
    summary:
      '平台更新了推荐机制的若干细则，取消了部分历史权重，中小创作者的反馈呈现明显分化，有人看作是机会，也有人担心被稀释。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20rising%20bar%20chart%20and%20arrow%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-08&orientation=squarish',
    coverAlt: '平台流量规则调整话题封面，暖色调抽象拼贴',
    tags: ['平台规则', '创作者', '流量'],
    publishedAt: '2026-09-10 15:30',
    updatedAt: '2026-09-11 09:10',
    heat: 5760,
    views: 52400,
    comments: 870,
    author: '编辑部 · 观察员',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '规则变了什么',
        paragraphs: [
          '本次更新主要涉及三处：一是降低了历史累计数据的权重，二是提高完播率与互动的即时影响，三是对同类内容的重复推荐做了更严格的限制。官方说明称，调整是为了让新内容获得更公平的起跑线。',
          '对长期稳定产出、粉丝基数较大的账号而言，历史权重下降意味着需要重新适应；对刚起步的创作者，这确实降低了冷启动的门槛。',
        ],
      },
      {
        heading: '中小创作者的真实反馈',
        paragraphs: [
          '反馈明显分化。有创作者晒出数据，称新规实施后单条作品的初始推荐量确实上升；也有创作者表示，由于完播率被赋予更高权重，内容风格被迫向更“短平快”的方向倾斜。',
          '一位运营者提到，规则本身没有绝对的好坏，关键是创作者能否理解它背后的取舍逻辑。',
        ],
      },
      {
        heading: '内容生态的长期影响',
        paragraphs: [
          '从更长的周期看，推荐机制每一次调整都会重塑内容形态。提高互动权重，可能带来更明确的开场结构；限制重复推荐，则可能鼓励差异化的选题。',
          '这些变化不会立刻显现，我们会在后续的行业风云栏目中保持跟踪。',
        ],
      },
    ],
  },
  {
    id: 'fan-club-governance',
    title: '粉丝社群公开治理公约，应援集资迎来新规',
    categorySlug: 'buzz',
    categoryName: '网络热议',
    summary:
      '数个较大规模的粉丝社群联合发布了一份治理公约，重点规范集资与应援流程，也首次公开了账目公示的方式。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20connected%20circles%20and%20handshake%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-09&orientation=squarish',
    coverAlt: '粉丝社群治理公约话题封面，暖色调抽象拼贴',
    tags: ['粉丝社群', '治理', '集资'],
    publishedAt: '2026-09-09 18:40',
    updatedAt: '2026-09-10 20:30',
    heat: 4980,
    views: 41600,
    comments: 720,
    author: '编辑部 · 星河',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '公约里写了什么',
        paragraphs: [
          '这份公约由多个粉丝社群共同整理，覆盖了集资发起流程、账目公示周期、应援物料的采购与结算方式等具体环节，并提出了“无公示、不集资”的基本原则。',
          '相比以往口头约定的松散规则，公约把每个环节的责任人、时间节点都写进了条款。',
        ],
      },
      {
        heading: '为什么治理越来越重要',
        paragraphs: [
          '随着粉丝组织规模扩大，集资金额与项目复杂度的上升，让信任机制成为刚需。过去几年中，账目不清、项目执行不到位引发的争议并不少见，也消耗了大量社群内部的信任。',
          '有法学背景的粉丝参与了条款起草，把相关法律法规的要求转化成社群能理解的操作规范。',
        ],
      },
      {
        heading: '落地面临的现实难题',
        paragraphs: [
          '公约发布后，讨论的焦点转向执行：谁来监督、争议如何裁定、资金托管用什么方式，这些问题在条款中仍有留白。',
          '有参与者坦言，公约的价值不在于一次写完美，而在于建立一个可以持续修订的框架。我们会在话题页跟进后续版本的更新。',
        ],
      },
    ],
  },
  {
    id: 'brand-cooperation-pull',
    title: '品牌合作临时调整，代言物料紧急下架引发讨论',
    categorySlug: 'industry',
    categoryName: '行业风云',
    summary:
      '某品牌与代言人的合作在官宣数日后出现调整，相关物料被撤下，双方均未给出详细说明，行业的风险评估机制再次被提及。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20shield%20and%20rising%20line%20chart%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-10&orientation=squarish',
    coverAlt: '品牌合作调整话题封面，暖色调抽象拼贴',
    tags: ['品牌合作', '代言', '公关'],
    publishedAt: '2026-09-09 14:20',
    updatedAt: '2026-09-10 11:00',
    heat: 5420,
    views: 48900,
    comments: 810,
    author: '编辑部 · 橙子',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '官宣与调整之间只隔了几天',
        paragraphs: [
          '合作官宣时，双方都发布了配合度很高的宣传内容，相关话题一度登上讨论榜。但在数日之后，品牌官方渠道下的合作物料被陆续撤下，线下门店的展示也做了更换。',
          '双方均未就调整原因发布正式说明，这也让外界的猜测有了空间。',
        ],
      },
      {
        heading: '行业里的风险评估机制',
        paragraphs: [
          '事实上，成熟的品牌合作通常包含舆情风险条款，用于约定在出现特定情形时的处理方式与责任划分。这类条款近年来在合同中的比重明显上升。',
          '有市场从业者表示，物料撤下不等于合作必然终止，也可能是阶段性的调整。在缺乏官方信息的情况下，外界很难判断具体走到哪一步。',
        ],
      },
      {
        heading: '对双方的短期与长期影响',
        paragraphs: [
          '短期看，快速调整有助于控制风险；长期看，频繁的临时变动也会影响品牌在合作方眼中的稳定性。如何平衡，是每个市场团队都要面对的课题。',
          '我们会在有进一步公开信息时更新本话题。',
        ],
      },
    ],
  },
  {
    id: 'streaming-price-change',
    title: '长视频平台调整会员权益，用户最在意的是这三点',
    categorySlug: 'industry',
    categoryName: '行业风云',
    summary:
      '平台更新了会员说明，涉及清晰度档位与同时在线设备的限制。相比价格本身，用户更关注权益是否被“悄悄缩水”。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20screen%20and%20tiered%20level%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-11&orientation=squarish',
    coverAlt: '长视频平台会员权益调整话题封面，暖色调抽象拼贴',
    tags: ['会员', '平台', '权益'],
    publishedAt: '2026-09-08 10:05',
    updatedAt: '2026-09-09 16:40',
    heat: 4620,
    views: 39800,
    comments: 660,
    author: '编辑部 · 观察员',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '调整的细则',
        paragraphs: [
          '本次更新主要涉及清晰度档位的会员等级划分，以及同时在线设备数量的上限。平台表示，调整是为了覆盖持续上升的内容与带宽成本。',
          '细则发布后，相关讨论很快集中到“老会员是否受影响”这一具体问题上。',
        ],
      },
      {
        heading: '用户最在意的三点',
        paragraphs: [
          '第一是过渡安排，即已购会员在到期前是否还能使用原有权益；第二是权益的可预期性，用户希望规则不要频繁变动；第三是价格与权益的匹配度，涨价本身可以讨论，但不希望权益在不易察觉处缩水。',
          '有用户整理了一份新旧权益对照表，被广泛转发，这类自发的信息整理成了讨论中的重要依据。',
        ],
      },
      {
        heading: '平台与用户的长期博弈',
        paragraphs: [
          '内容平台的成本结构决定了权益调整难以避免，但如何沟通同样重要。提前公示、保留过渡期、把变化说清楚，往往比调整本身更能决定用户的去留。',
          '我们会在后续更新平台是否补充说明。',
        ],
      },
    ],
  },
  {
    id: 'award-season-buzz',
    title: '年度评选进入投票期，入围名单引发“分猪肉”讨论',
    categorySlug: 'variety',
    categoryName: '综艺热点',
    summary:
      '一项年度评选公布了入围名单，因为多个奖项的候选人高度重合，被部分网友质疑分配不够合理，主办方做出了回应。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20abstract%20collage%20of%20layered%20coral%20red%20and%20amber%20gold%20paper%20shapes%20on%20a%20cream%20textured%20background%2C%20soft%20film%20grain%2C%20minimal%20modern%20graphic%20design%2C%20trophy%20and%20ribbon%20motifs%2C%20no%20text%2C%20balanced%20composition&width=900&height=700&seq=hl-cov-12&orientation=squarish',
    coverAlt: '年度评选入围名单话题封面，暖色调抽象拼贴',
    tags: ['评选', '入围', '投票'],
    publishedAt: '2026-09-07 17:50',
    updatedAt: '2026-09-08 14:10',
    heat: 4380,
    views: 36200,
    comments: 590,
    author: '编辑部 · 星河',
    isFeatured: false,
    isBreaking: false,
    content: [
      {
        heading: '入围名单里的重合',
        paragraphs: [
          '名单公布后，有网友统计发现，多位候选人在三个以上奖项中同时出现，而部分表现同样亮眼的作品却未入围任何一个奖项，这种分布引发了“资源集中”的质疑。',
          '支持者则认为，候选人重合恰恰说明这些作品确实横跨多个维度，属于正常现象。',
        ],
      },
      {
        heading: '主办方的解释',
        paragraphs: [
          '主办方回应称，各奖项由不同的评审小组独立评选，重合并非有意安排；同时公布了评审流程与回避规则，以回应透明度方面的疑问。',
          '对于未入围的作品，主办方表示会考虑增设入围名额，但需要评估对投票环节的影响。',
        ],
      },
      {
        heading: '评选机制的公开讨论',
        paragraphs: [
          '这类争议每年都会出现，背后其实是评选机制本身的老问题：评委构成、投票权重、以及商业因素与专业判断的边界。把机制讲清楚，比反复澄清结果更有效。',
          '投票通道仍在开放，我们会在结果公布时更新本话题。',
        ],
      },
    ],
  },
];

export const featuredTopics = topics.filter((item) => item.isFeatured);
export const breakingTopics = topics.filter((item) => item.isBreaking);